import { createRouter, createWebHistory } from 'vue-router';
import Vue3linkify from 'vue-3-linkify';
import Cookies from 'js-cookie';
import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './vue/App.vue';
import DraftImage from './vue/components/draft/DraftImage.vue';
import Notifications_view from './vue/notifications_view.vue';
import Banner from './vue/./components/banner.vue';
import { notificationsStore } from './store';
import routes from './routes';
import { instance } from './api/instance';
import DraftFilePage from '@/dashboard/vue/pages/DraftFilePage.vue';
import ShortLinkPage from '@/dashboard/vue/pages/ShortLinkPage.vue';

const pinia = createPinia();

async function sendRequestWithInterval(
  url: string,
  params: object,
  intervalTime: number,
  onDataReceived: (data: unknown) => boolean,
  maxAttempts = 10
) {
  let attempts = 0;

  const fetchData = async () => {
    attempts++;

    try {
      const response = await instance.get(url, { params: { ...params } });

      if (onDataReceived(response.data)) {
        // Stop the interval if necessary data is received
        clearInterval(intervalId);
      } else if (attempts >= maxAttempts) {
        // Stop the interval after a certain number of attempts
        clearInterval(intervalId);
        console.log('Maximum attempts reached. Data not received.');
      }
    } catch (error: unknown) {
      console.error(`Error fetching data: ${(error as Error).message}`);
    }
  };

  // Initial call to start fetching data immediately
  await fetchData();

  // Set up interval for subsequent requests
  const intervalId = setInterval(fetchData, intervalTime);
}

export default function initApplication() {
  if (document.querySelector('#app')) {
    const router = createRouter({
      history: createWebHistory(),
      routes,
    });
    const app = createApp(App);
    app.directive('focus', {
      mounted(el) {
        el.focus();
      },
    });
    app.use(router);
    app.use(pinia);
    app.mount('#app');
  }

  if (document.querySelector('#draft_view')) {
    if (!document.querySelector('#draft_loading')) {
      const draftView = createApp(DraftImage);
      draftView.use(pinia);
      draftView.use(Vue3linkify);
      draftView.mount('#draft_view');
    } else {
      const link = (document.querySelector("[name='short_link']") as HTMLInputElement).value;
      const apiUrl = `/drafts/has_draft_by_link`;
      const params = { short_link: link };
      const intervalTime: number = 3000;

      (async () => {
        await sendRequestWithInterval(apiUrl, params, intervalTime, (data) => {
          if ((data as any).result) {
            window.location.reload();
          }

          return (data as any).result;
        });
      })();
    }
  }

  if (document.querySelector('#draft-file')) {
    const router = createRouter({
      history: createWebHistory(),
      routes: [{ path: '/:short_link', component: ShortLinkPage }],
    });
    const draftView = createApp(DraftFilePage);
    draftView.use(router);
    draftView.use(pinia);
    draftView.mount('#draft-file');
  }

  if (document.querySelector('#main-notifications')) {
    const draft_view = createApp(Notifications_view);
    draft_view.use(notificationsStore);
    draft_view.mount('#main-notifications');
  }

  if (document.querySelector('#banner')) {
    const banner_view = createApp(Banner);
    banner_view.mount('#banner');
  }

  if (document.querySelector('#cookie')) {
    const cookie = document.querySelector('#cookie');
    const btn = document.querySelector('#cookie-sure');

    btn?.addEventListener('click', () => {
      cookie?.classList.add('hidden');
      Cookies.set('cookie_accept', 'true', { expires: 365 });
    });
  }
}
